import styled, { css } from "styled-components";
import { Form } from "formik";
import { Form as FormBoot, Modal } from "react-bootstrap";

export const SelectTypeValidation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`;

export const FormRadioContent = styled.div`
  box-shadow: 0px 0px 10px -4px rgb(0 0 0 / 75%);
  display: flex;
`;

export const FormRadio = styled(FormBoot.Check)`
  padding: 0;

  .form-check-input {
    position: absolute;
    z-index: 10;
    opacity: 0;
  }

  .form-check-label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    line-height: normal;
    border-bottom: 0 solid #00ff00;
    text-align: center;
    background: #000fff;
    color: #fff;
    font-weight: bold;
    margin: 0;
    user-select: none;

    &::before,
    &::after {
      content: none;
    }
  }

  ${({ isSelect }) =>
    isSelect &&
    css`
      .form-check-label {
        border-width: 2px;
      }
    `}
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const Field = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: 100%;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ContentField = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  gap: 15px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2px;
    margin-bottom: 10px;
  }

  & div:first-of-type {
    margin-bottom: 0;
  }
`;

export const ContentToken = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  border-top: 1px dashed #d8d8d8;

  #content-buttons {
    flex-direction: column;
    gap: 15px;

    > button {
      width: 100%;
    }
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    width: 40%;
  }
`;

export const TextLabel = styled.span`
  color: #0b24fb;
`;

export const TextTimer = styled.p`
  text-align: center;

  a {
    color: #0000ff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    place-content: space-between;

    div {
      display: flex;
      flex-direction: column;

      h2 {
        margin: 0;
        color: #0b24fb;
        font-size: 18px;
        font-weight: 400;
      }
      span {
        color: #7a7a7a;
      }
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
    cursor: pointer;
    margin-left: 10px;
  }

  margin-bottom: 16px;
`;
